import React from "react"

export default function BorderWrapper(options) {
    return(
        <div className={'gradient-border'}
             style={{borderRadius:options.radius, height:options.height, width:options.width,padding:options.padding, margin:options.margin }}
        >
            {options.children}
        </div>
    )
}